import { render, staticRenderFns } from "./NtpInfo.vue?vue&type=template&id=0d43119e&scoped=true&v-if=ntpInfo.data.length%20%3E%200&"
import script from "./NtpInfo.vue?vue&type=script&lang=js&"
export * from "./NtpInfo.vue?vue&type=script&lang=js&"
import style0 from "./NtpInfo.vue?vue&type=style&index=0&id=0d43119e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d43119e",
  null
  
)

export default component.exports